import React from "react";
import { Button, Tag, Picker, List, Modal, Toast } from "antd-mobile";
import { withRouter } from "react-router-dom";
import GoBack from "../../components/GoBack";
import withAuth from "../../HOCs/withAuth";
import "./AppointmentPosition.scss";
import http from "../../util/api.js";
const { alert } = Modal;

// 职位安排表
const residJobArrange = 617311643033;
// 公司信息表
const cropResid = 617190452853;
// 招聘职务管理表
const resid = 617195632278;
// 求职记录表
const residJobSeeker = 617278498676;

class AppointmentPosition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectDate: "",
      dataInfo: {},
      dataCrop: {},
      jobArrangeInfo: [],
      auditionTime: [],
      positioninfo: {
        tags: ""
      },
      confirmModalVisible: false
    };
  }

  componentDidMount() {
    window.V5CHAT("hideBtn");
    // 职位编号
    const id = this.props.match.params.id;
    this.getPositioninfo(id);
    this.onSearch();
    this.onSearchJob(id);
    // 清除缓存
    // http().clearCache();
    window.V5CHAT("hideBtn");
  }

  // C3_635013257335 是否远程
  //获取职位详情
  getPositioninfo = async id => {
    try {
      let res = await http().getTable({
        resid,
        cmswhere: `jobId = ${id}`
      });
      let { data } = res;
      if (data.data.length) {
        this.setState({ positioninfo: data.data[0] });
        Toast.hide();
      } else {
        Toast.info("无职位信息", 2, () => {
          this.props.history.push("/home");
        });
      }
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  // 点击确认预约
  showConfim = () => {
    let { selectDate } = this.state;
    if (!selectDate.length) {
      return Toast.fail("请选择预约日期");
    }
    this.setState({ confirmModalVisible: true });
  };

  handleConfirm = async e => {
    const { positioninfo, dataInfo, selectDate } = this.state;
    Toast.loading();
    const data = [
      {
        job: dataInfo.jobName,
        salary: dataInfo.salary,
        interviewTime: selectDate.length > 0 ? selectDate[0] : "",
        jobId: positioninfo.jobId
      }
    ];
    try {
      let res = await http().addRecords({
        resid: residJobSeeker,
        data
      });
      this.onSuccess(res.data.data[0].interviewId);
    } catch (error) {
      console.error(error);
      Toast.fail(error.message, 2);
    }
  };

  onSuccess = interviewId => {
    const { positioninfo } = this.state;
    alert("预约成功", "", [
      {
        text: "确定",
        onPress: () => {
          if (positioninfo.C3_635013257335 === "Y") {
            this.props.history.push(`/interview-detail-new/${interviewId}`);
          } else {
            this.props.history.push(`/interview_detail/${interviewId}`);
          }
        }
      }
    ]);
  };

  // 查询公司信息
  onSearch = async () => {
    let res;
    try {
      res = await http().getPublicTable({
        resid: cropResid
        // data:''
      });
      this.setState({ dataCrop: res.data.data[0] });
    } catch (error) {
      console.log(error);
    }
  };

  // 查询职位面试安排表
  onSearchJob = async id => {
    let res;
    try {
      res = await http().getTable({
        resid: residJobArrange,
        cmswhere: `C3_618321083100=${id}`
        // C3_617810718704: this.state.dataInfo.jobId
      });
      this.setState({ jobArrangeInfo: res.data.data }, () => {
        this.handleAuditionTime();
      });
    } catch (error) {
      console.log(error);
    }
  };

  //处理安排时间
  handleAuditionTime = () => {
    let { jobArrangeInfo, auditionTime } = this.state;
    jobArrangeInfo.map(item => {
      auditionTime.push({
        label: `${item.interviewTime}  剩余:${item.C3_617984765009}`,
        value: item.interviewTime
      });
    });
  };

  goBack = () => {
    this.props.history.push(`/position_info/${this.props.match.params.id}`);
  };
  render() {
    let { dataCrop, auditionTime, confirmModalVisible } = this.state;
    let tags = this.state.positioninfo.tags;
    let tags1 = tags.split(",");
    return (
      <div className="appointing_position">
        <GoBack goBack={this.goBack} />
        <div className="position_intro">
          <span className="position_name">
            {this.state.positioninfo.jobName}
          </span>
          <span className="position_salary">
            {this.state.positioninfo.salary}/月
          </span>
        </div>
        <div className="interview_date">
          <Picker
            data={auditionTime}
            // data={this.jobArrangeInfo.interviewTime}

            title="选择面试日期"
            extra="请选择面试日期"
            className="select_date"
            cols={1}
            value={this.state.selectDate}
            onChange={value => {
              this.setState({ selectDate: value });
            }}
          >
            <List.Item arrow="horizontal">面试日期</List.Item>
          </Picker>
        </div>
        <div className="corporation_info">
          <h3>公司向导</h3>
          <p>
            <label>地址: </label>
            {dataCrop.address}
          </p>
          <p>
            <label>公交: </label>
            {dataCrop.transit}
          </p>
          <p>
            <label>电话: </label>
            {dataCrop.phone}
          </p>
          <p>
            <label>传真: </label>
          </p>
          <p>
            <label>电邮: </label>
          </p>
        </div>
        <div className="position_descrition">
          <h3>职位描述</h3>
          <div className="description_main">
            <p>{this.state.positioninfo.jobDis}</p>
            <div className="position_tags">
              {tags1.map((item, index) => {
                return <Tag key={index}>{item}</Tag>;
              })}
            </div>
          </div>
          <div className="confirm_btn">
            <Button type="primary" onClick={this.showConfim.bind(this)}>
              确认预约
            </Button>
          </div>
        </div>
        <Modal
          popup
          visible={confirmModalVisible}
          onClose={() => this.setState({ confirmModalVisible: false })}
          animationType="slide-up"
        >
          <div
            style={{
              color: "#000",
              padding: 8,
              overflow: "auto"
            }}
          >
            <h2>预约面试前，请详细阅读以下内容。</h2>
            <div
              style={{
                textAlign: "left",
                height: "60vh",
                overflow: "auto",
                paddingBottom: 12
              }}
            >
              {/* <p style={{ textIndent: "2em" }}>
                预约面试前，请详细阅读以下内容。
              </p> */}
              <p style={{ textIndent: "2em" }}>
                菲尼萨光电通讯科技（无锡）有限公司成立于2011年8月，位于无锡新区综合保税区，投资额2.25亿美元，于2011年11月正式投入生产,公司主要生产光通讯设备和元器件。无锡公司的规模持续扩大，正处于高速发展阶段，现急需大量优秀人员的加入。我们将为聘用人员提供优厚的薪资待遇和广阔的发展空间！
              </p>
              <section>
                <h3>公司地址：</h3>
                <ul style={{ marginLeft: "2em" }}>
                  <li>江苏省无锡市高新区综合保税区Z3-1地块</li>
                </ul>
              </section>
              <section>
                <h3>交通提示：</h3>
                <ul style={{ marginLeft: "2em" }}>
                  <li>
                    综合保税区高浪东路大门进入，直行1000米穿过高架桥右手边即为菲尼萨公司
                  </li>
                </ul>
              </section>
              <section>
                <h3>联系方式：</h3>
                <ul style={{ marginLeft: "2em" }}>
                  <li>0510-68007800-7632/7631</li>
                </ul>
              </section>
              <section>
                <h3>工作内容：</h3>
                <ul style={{ marginLeft: "2em" }}>
                  <li>
                    移动通信类（应用于4G、5G通信设备）和数据传输类（应用于大数据、云计算等产业）产品的生产、组装、焊接、检验、测试、封装以及机器维护、产品开发等工作。
                  </li>
                </ul>
              </section>
              <section>
                <h3>岗位要求：</h3>
                <ul style={{ marginLeft: "2em" }}>
                  <li>初中及以上学历，18周岁及以上；</li>
                  <li>适应无尘车间的工作环境，穿戴无尘衣，可看显微镜；</li>
                  <li>适应12h的倒班制度；</li>
                </ul>
              </section>
              <section>
                <h3>薪资福利：</h3>
                <ul style={{ marginLeft: "2em" }}>
                  <li>
                    大专以下学历基本工资2425~2675元，大专及以上基本工资2525~2775元，工作满两年增加100元工龄工资，综合月薪3500~4500元；年终至少13薪；
                  </li>
                  <li>
                    各类补贴：绩效补贴150元/月；夜班补贴18元/次；显微镜补贴100元/月；
                  </li>
                  <li>
                    住宿（现代化标准6人公寓）或享受住房补贴100元/月；免费工作餐（12小时工作2顿标准正餐）；厂车接送或享受交通补贴100元/月；
                  </li>
                  <li>
                    规范的五险一金（社保与公积金）加补充医疗保险（门诊费用报销90%，住院费报销100%）；
                  </li>
                  <li>
                    入职第一年即按比例享受8天年假，服务每满一年增加1天，最高可享受15天；婚假、丧假、计划生育假享受100%薪资；病假等享受60%薪资，依服务年限做相应调整；
                  </li>
                  <li>
                    教育资助计划：工作业余时间获得高一级学历，可享受1000（大专）—20000元教育资助；
                  </li>
                  <li>
                    员工生日、端午节、中秋、春节等节日给予贺礼；每季度150元/人的团队建设经费，用于部门或团队活动；公司开展丰富多彩的文化活动（运动会、俱乐部、旅游、年夜饭等）。
                  </li>
                </ul>
              </section>
              <section>
                <h3>培训发展：</h3>
                <ul style={{ marginLeft: "2em" }}>
                  <li>
                    富有特色的新员工导师计划（培训师或者Mentor），帮助员工快速适应企业文化；
                  </li>
                  <li>
                    完善的入职培训、多岗轮训、企业外训、应届生培养计划以及广泛的国外交流机会；
                  </li>
                  <li>来自国内985、211等顶尖院校的优秀同事与您共同成长；</li>
                  <li>技术、管理两大方向的广阔发展空间和晋升机会。</li>
                </ul>
              </section>
            </div>
            <div
              style={{
                paddingTop: 12,
                background: "rgba(255, 255, 255, 1)",
                boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.4)"
              }}
            >
              <Button type="primary" onClick={this.handleConfirm}>
                我已阅读
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
// export default withRouter(AppointmentPosition)
export default withAuth(AppointmentPosition);
